export default "__VITE_ASSET__3sC8UXRo__"